import { createStyles, useTheme, withStyles } from '@material-ui/styles';
import { setProp, toCssValue } from '@topconagriculture/theme';
import classNames from 'classnames';
import * as React from 'react';
export const isNumber = (value) => typeof value === 'number';
const styles = (theme) => createStyles({
    root: {
        color: 'inherit',
        fontSize: theme.font.size.medium,
        fontWeight: theme.font.weight.normal,
        lineHeight: theme.font.lineHeight.small,
    },
    caption: {
        fontSize: theme.font.size.caption,
        lineHeight: theme.font.lineHeight.small,
    },
    title: {
        fontWeight: theme.font.weight.bold,
        lineHeight: theme.font.lineHeight.medium,
        fontSize: theme.font.size.title,
    },
    heading: {
        fontWeight: theme.font.weight.bold,
        lineHeight: theme.font.lineHeight.medium,
        fontSize: theme.font.size.heading,
    },
    paragraph: {
        lineHeight: theme.font.lineHeight.mediumBig,
        fontSize: theme.font.size.medium,
        textAlign: 'justify',
    },
    underline: {
        textDecoration: 'underline',
    },
    shadowText: {
        textShadow: '0 1px 2px #484848',
    },
    ellipsis: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    wrap: {
        overflowWrap: 'break-word',
    },
    backLineText: {
        display: 'inline-table',
        maxWidth: 'fit-content',
        padding: toCssValue([0, theme.space.padding.default]),
    },
});
const Text = (props) => {
    const { classes, className: classNameProp, style, children, type = '', transform, underline, shadow, size, lineHeight, title, decoration, ellipsis, backLineColor, wrap, backLineColorOpacity, fallback, onClick, testId, } = props;
    const theme = useTheme();
    const textClasses = classNames(type ? classes[type] : null, {
        [classes.root]: true,
        [classes.shadowText]: shadow,
        [classes.ellipsis]: ellipsis,
        [classes.wrap]: wrap,
        [classes.underline]: underline,
        [classes.backLineText]: backLineColor,
    }, classNameProp);
    const sizeVal = size && (isNumber(size) ? size : theme.font.size[size || 'medium']);
    const lineHeightVal = lineHeight && (isNumber(lineHeight) ? lineHeight : theme.font.lineHeight[lineHeight || 'medium']);
    let textColor = props.color;
    if (props.color === 'dark' || props.color === 'light') {
        textColor = theme.color.font[props.color];
    }
    const backLineColorToRgba = (hexColor, backLineOpacity = 0.4) => {
        if (hexColor) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
            const col = result
                ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16),
                }
                : null;
            return col && `rgba(${col.r}, ${col.g}, ${col.b}, ${String(backLineOpacity)})`;
        }
        return null;
    };
    let inlineStyles = { ...style };
    inlineStyles = setProp(inlineStyles, 'fontSize', sizeVal);
    inlineStyles = setProp(inlineStyles, 'lineHeight', lineHeightVal);
    inlineStyles = setProp(inlineStyles, 'color', textColor);
    inlineStyles = setProp(inlineStyles, 'display', props.maxWidth ? 'inline-block' : props.block && 'block');
    inlineStyles = setProp(inlineStyles, 'fontStyle', props.italic && 'italic');
    inlineStyles = setProp(inlineStyles, 'fontWeight', props.bold && theme.font.weight.bold);
    inlineStyles = setProp(inlineStyles, 'fontWeight', props.light && theme.font.weight.light);
    inlineStyles = setProp(inlineStyles, 'textTransform', props.transform && transform);
    inlineStyles = setProp(inlineStyles, 'textDecoration', props.decoration && decoration);
    inlineStyles = setProp(inlineStyles, 'maxWidth', props.maxWidth);
    inlineStyles = setProp(inlineStyles, 'cursor', props.onClick ? 'pointer' : undefined);
    inlineStyles = setProp(inlineStyles, 'boxShadow', backLineColor &&
        `inset 0 -${lineHeightVal ? lineHeightVal / 2 : '0.5'}em 0 0
      ${backLineColorToRgba(backLineColor, backLineColorOpacity)}`);
    const fallbackText = fallback ? fallback : null;
    const content = children === '' || !children ? fallbackText : children;
    return (React.createElement("span", { title: title, style: inlineStyles, className: textClasses, onClick: onClick ? onClick : null, "data-testid": testId }, content));
};
Text.displayName = 'Text';
export default withStyles(styles)(Text);
//# sourceMappingURL=Text.js.map